<template>
    <span v-if="!deletedAt" class="inline-flex leading-5 font-semibold rounded-full">
        <span
            :class="[
                badgeClasses,
                'rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset',
                variant === 'hero' ? 'backdrop-blur' : '',
            ]"
        >
            {{ label }}
        </span>
    </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    lifecycleStatus: {
        type: Object,
        required: true,
    },
    deletedAt: {
        type: [String, null],
        default: null,
    },
    variant: {
        type: String,
        default: 'index',
        validator: (value) => ['index', 'hero'].includes(value),
    },
})

const label = computed(() => props.lifecycleStatus?.label ?? 'Unknown')
const badgeClasses = computed(() => {
    if (props.variant === 'hero') {
        return props.lifecycleStatus?.badge_classes ?? 'text-sky-50 bg-sky-700/80 ring-sky-200/40'
    }

    return props.lifecycleStatus?.index_badge_classes ?? 'text-sky-700 bg-sky-50 ring-sky-600/20'
})
</script>
